export const breakpoints = {
  xl: 'screen and (min-width: 1440px)',
  lg: 'screen and (min-width: 1040px)',
  md: 'screen and (min-width: 768px)',
  sm: 'screen and (min-width: 490px)',
  xs: 'screen and (max-width: 489px)',
};
